const initialState = {
    hotels: [],
  };
  
  const hotelListingReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_HOTELS':
        return {
          ...state,
          hotels: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default hotelListingReducer;
  